module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "fitbit-sleep-stages"
    }
  }, [(_vm.fitbitData.sleep.length > 0) ? _c('mu-card', [_c('mu-divider'), _vm._v(" "), _c('mu-row', [_c('mu-col', {
    staticStyle: {
      "border-right": "1px solid #e0e0e0"
    },
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-card-header', {
    attrs: {
      "titleClass": "largeTitle blackTitle",
      "title": "Time asleep",
      "subTitleClass": "timeAsleep",
      "subTitle": _vm.normalizeDuration(_vm.sleepBreakdown.total)
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "50",
      "desktop": "50",
      "tablet": "50"
    }
  }, [_c('mu-card-header', {
    attrs: {
      "titleClass": "largeTitle blackTitle",
      "title": "Time in bed",
      "subTitleClass": "timeAsleep",
      "subTitle": _vm.normalizeDuration(_vm.sleepBreakdown.totalInBed)
    }
  })], 1)], 1), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('mu-card-header', {
    attrs: {
      "titleClass": "largeTitle blackTitle",
      "title": "Stages of sleep",
      "subTitle": _vm.date
    }
  }), _vm._v(" "), _c('mu-divider'), _vm._v(" "), (_vm.sleepBreakdown && _vm.sleepBreakdown.type === 'classic') ? _c('div', [_c('mu-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-col', {
    staticClass: "padding",
    staticStyle: {
      "border-right": "1px solid #e0e0e0"
    },
    attrs: {
      "width": "33",
      "desktop": "33",
      "tablet": "33"
    }
  }, [_c('div', [_c('strong', [_vm._v("Awake")])]), _vm._v(" "), _c('div', [_vm._v(" " + _vm._s(_vm.normalizeDuration(_vm.sleepBreakdown.minutes.awake)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.sleepBreakdown.formatted.awake) + "%")])]), _vm._v(" "), _c('mu-col', {
    staticClass: "padding",
    staticStyle: {
      "border-right": "1px solid #e0e0e0"
    },
    attrs: {
      "width": "33",
      "desktop": "33",
      "tablet": "33"
    }
  }, [_c('div', [_c('strong', [_vm._v("Asleep")])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.normalizeDuration(_vm.sleepBreakdown.minutes.asleep)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.sleepBreakdown.formatted.asleep) + "%")])]), _vm._v(" "), _c('mu-col', {
    staticClass: "padding",
    attrs: {
      "width": "33",
      "desktop": "33",
      "tablet": "33"
    }
  }, [_c('div', [_c('strong', [_vm._v("Restless")])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.normalizeDuration(_vm.sleepBreakdown.minutes.restless)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.sleepBreakdown.formatted.restless) + "%")])])], 1), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('mu-card-text', {
    staticStyle: {
      "padding-top": "0"
    }
  }, [_c('div', {
    staticClass: "accreditation"
  }, [_c('img', {
    staticStyle: {
      "width": "24px"
    },
    attrs: {
      "src": "static/integrations/fitbit.svg"
    }
  }), _vm._v("\n        Data from FitBit\n      ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.sleepBreakdown && _vm.sleepBreakdown.type === 'stages') ? _c('mu-card-text', [_c('div', [_c('div', {
    staticClass: "rail"
  }, [_c('div', {
    staticClass: "percentage-bar awake",
    style: ({
      'width': _vm.sleepBreakdown.formatted.wake + '%'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "afterText"
  }, [_c('div', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.sleepBreakdown.formatted.wake) + "% awake")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.normalizeDuration(_vm.sleepBreakdown.minutes.wake)))])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    staticClass: "rail"
  }, [_c('div', {
    staticClass: "percentage-bar rem",
    style: ({
      'width': _vm.sleepBreakdown.formatted.rem + '%'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "afterText"
  }, [_c('div', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.sleepBreakdown.formatted.rem) + "% REM")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.normalizeDuration(_vm.sleepBreakdown.minutes.rem)))])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    staticClass: "rail"
  }, [_c('div', {
    staticClass: "percentage-bar light",
    style: ({
      'width': _vm.sleepBreakdown.formatted.light + '%'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "afterText"
  }, [_c('div', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.sleepBreakdown.formatted.light) + "% light")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.normalizeDuration(_vm.sleepBreakdown.minutes.light)))])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "percentage-bar deep",
    style: ({
      'width': _vm.sleepBreakdown.formatted.deep + '%'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "afterText"
  }, [_c('div', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.sleepBreakdown.formatted.deep) + "% deep")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.normalizeDuration(_vm.sleepBreakdown.minutes.deep)))])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "accreditation"
  }, [_c('img', {
    staticStyle: {
      "width": "24px"
    },
    attrs: {
      "src": "static/integrations/fitbit.svg"
    }
  }), _vm._v("\n        Data from FitBit\n      ")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.fitbitData.sleep.length === 0) ? _c('mu-card', [_c('mu-card-header', {
    attrs: {
      "titleClass": "largeTitle blackTitle",
      "title": "No data",
      "subTitle": _vm.date
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53de3074","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tracking/Graphs/Sleep/FitbitSleepStages.vue
// module id = 3175
// module chunks = 1